import OutroPage from "./OutroPage";

export default OutroPage;
